import React, { Component } from "react";
// For test purpose - TODO: change later if needed to prod data or so
import data from '../utils/mockedData';
import "./App.scss";
import DataPanel from "./dataPanel/DataPanel";
// Component import
import Header from "./header/Header";
import PlaybackPanel from "./playbackPanel/PlaybackPanel";
import VideoPanel from "./videoPanel/VideoPanel";
import VideoSwapMenu from './videoSwapMenu/VideoSwapMenu';


class App extends Component {
	state = {
		currentPlaybackTime: 	0,			// Current time of the playback of the video
		currentlyPlaying: 		false,		// Whether videos are currently playing ot nor
		videoReady: 			false,		// Whether the videos are ready to play or not
		videoDuration: 			null,		// Duration of the video
		navTo: 					1, 			// Value to navigate the video to - initially we want to start at 1, can be updated from sub-components

		selectedVideos: [
			data.metadata.videos[0],
			data.metadata.videos[1]
		],

		isSwapMenuOpen: false,
		swapMenuSelectedVideo: null,
		selectedVideoIndex: 1
	};

	/**
	 * Set current playback time
	 * @param currentPlaybackTime
	 */
	updatePlaybackTime = (currentPlaybackTime) => this.setState({currentPlaybackTime});

	/**
	 * Set video duration
	 * @param videoDuration
	 */
	updateVideoDuration = (videoDuration) => {
		if( videoDuration && !this.state.videoDuration ) // Make sure we don't set the duration multiple times
			this.setState({videoDuration})
	};

	/**
	 * Set navTo to tell the player to navigate to a certain value
	 * @param navTo
	 */
	updateNavTo	= (navTo) => this.setState({navTo});

	/**
	 * Pause playback
	 */
	pausePlayState = () => this.setState({currentlyPlaying: false, navTo: undefined});

	/**
	 * Start playback
	 */
	playPlayState = () => {
		this.setState({
			currentlyPlaying: true,
			navTo: this.state.videoDuration ===  this.state.currentPlaybackTime ? 1 : this.state.navTo // If we play after reaching the end - set navTo to 1sec
		})
	};

	/**
	 * Toggle playback
	 */
	toggleCurrentPlayState = () => {
		if( this.state.currentlyPlaying )
			this.pausePlayState();
		else
			this.playPlayState();
	};

	/**
	 * Toggle video ready
	 */
	toggleVideoReady = () => this.setState({videoReady: !this.state.videoReady});

	/**
	 *  Toggle video swap menu opening
	 */
	toggleIsSwapMenuOpen = () => this.setState({isSwapMenuOpen: !this.state.isSwapMenuOpen});

	/**
	 * Set selected video index
	 * @param selectedVideoIndex
	 */
	setSelectedVideoIndex = selectedVideoIndex => this.setState({selectedVideoIndex});

	/**
	 * Set selected video for swipe menu
	 * @param swapMenuSelectedVideo
	 */
	setSwapMenuSelectedVideo = swapMenuSelectedVideo => {
		this.setState({
			swapMenuSelectedVideo,
		});
	};

	/**
	 * Swap active video for new one
	 * @param swapMenuSelectedVideo
	 */
	swapVideo = (swapMenuSelectedVideo) => {
		let newSelectedVideos = this.state.selectedVideos;
		newSelectedVideos[this.state.selectedVideoIndex] = swapMenuSelectedVideo;
		this.setState({
			swapMenuSelectedVideo,
			selectedVideos: newSelectedVideos,
			navTo: this.state.currentPlaybackTime
		});
	};

	render() {
		return (
			<div className="App layout-column">
				<div className={`header`}>
					<Header
						tripId={data.metadata.lid}
						tripDate={new Date(data.data[0].wallClock.utc + data.data[0].wallClock.tzo)}
					/>
				</div>

				<div className={`videoPanel`}>
					<VideoPanel
						currentlyPlaying={this.state.currentlyPlaying}
						selectedVideos={this.state.selectedVideos}
						navTo={this.state.navTo}


						isSwapMenuOpen={this.state.isSwapMenuOpen}
						selectedVideoIndex={this.state.selectedVideoIndex}

						updatePlaybackTime={this.updatePlaybackTime}
						toggleVideoReady={this.toggleVideoReady}
						updateVideoDuration={this.updateVideoDuration}
						pausePlayState={this.pausePlayState}
						playPlayState={this.playPlayState}

						toggleIsSwapMenuOpen={this.toggleIsSwapMenuOpen}
						setSwapMenuSelectedVideo={this.setSwapMenuSelectedVideo}
						setSelectedVideoIndex={this.setSelectedVideoIndex}
					/>
				</div>

				<div className="layout-column flex App__lowerContainer">
					<div className={`dataPanel flex`}>
						<DataPanel 
							currentPlaybackTime={this.state.currentPlaybackTime}
							currentlyPlaying={this.state.currentlyPlaying}
							data={data.data}
							tripGps={data.metadata.tripGps}
							videoReady={this.state.videoReady}
						/>
					</div>

					<div className={`playbackPanel`}>
						<PlaybackPanel
							currentPlaybackTime={this.state.currentPlaybackTime}
							videoReady={this.state.videoReady}
							videoDuration={this.state.videoDuration}
							currentlyPlaying={this.state.currentlyPlaying}

							toggleCurrentPlayState={this.toggleCurrentPlayState}
							pausePlayState={this.pausePlayState}
							playPlayState={this.playPlayState}

							updateNavTo={this.updateNavTo}
						/>
					</div>

					<VideoSwapMenu
						videos={data.metadata.videos}
						open={this.state.isSwapMenuOpen}
						toggleOpen={this.toggleIsSwapMenuOpen}
						selectedVideoIndex={this.state.selectedVideoIndex}
						swapVideo={this.swapVideo}
					/>
				</div>
			</div>
		);
	}
}

export default App;
